// extracted by mini-css-extract-plugin
export default {"section":"CefrTool_section__taTSR","versionsContainer":"CefrTool_versionsContainer__Mys18","chip":"CefrTool_chip__hLY+M","inputWrapper":"CefrTool_inputWrapper__HUcLD"};